module.exports = __webpack_public_path__ + "img/straight_line2_icon.c6077146.svg";